<template>
  <div>
    <custom-actions show-back>
      <el-form class="global-form shoufa-form" :model="formData" :rules="rules" ref="form" label-width="130px"
               v-loading="loading">
        <el-row>
          <el-col :span="12">
            <el-form-item prop="inspectionType" label="检验类型">
              <el-select v-model="formData.inspectionType" clearable filterable placeholder="请选择检验类型">
                <el-option v-for="(item, index) of inspectionTypeArr" :value="item.value" :label="item.label"
                           :key="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="specId" label="产品规格">
              <el-select v-model="formData.specId" clearable filterable placeholder="请选择产品规格">
                <el-option v-for="(item, index) of specList" :value="item.specId" :label="item.specName"
                           :key="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item prop="productionDate" label="生产日期">
              <el-date-picker v-model="formData.productionDate" placeholder="请选择生产日期" type="date" clearable
                              format="yyyy-MM-dd" value-format="yyyy-MM-dd" @change="calcExpireDate">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="shelfLifeMonth" label="保质期(月)">
              <el-input-number v-model="formData.shelfLifeMonth" placeholder="输入保质期月份" :min="1" clearable @change="calcExpireDate" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item prop="shelfLifeEndDate" label="保质期至">
              <el-input v-model="formData.shelfLifeEndDate" disabled placeholder="自动计算生成"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item prop="productionLine" label="生产线">
              <el-input v-model="formData.productionLine" clearable placeholder="请输入生产线"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item prop="labelCorrect" label="标签是否正确">
              <el-radio-group v-model="formData.labelCorrect">
                <el-radio label="1">正常</el-radio>
                <el-radio label="2">异常</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="sprayCodeCorrect" label="喷码是否正确">
              <el-radio-group v-model="formData.sprayCodeCorrect">
                <el-radio label="1">正常</el-radio>
                <el-radio label="2">异常</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item prop="capIntact" label="压盖是否完好">
              <el-radio-group v-model="formData.capIntact">
                <el-radio label="1">正常</el-radio>
                <el-radio label="2">异常</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="bottleImpurity" label="瓶内是否有杂质">
              <el-radio-group v-model="formData.bottleImpurity">
                <el-radio label="1">正常</el-radio>
                <el-radio label="2">异常</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item prop="bottleWallIntact" label="瓶外壁是否完好">
              <el-radio-group v-model="formData.bottleWallIntact">
                <el-radio label="1">正常</el-radio>
                <el-radio label="2">异常</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item prop="remark" label="备注" :required="hasErr">
              <el-input type="textarea" v-model="formData.remark" clearable rows="3" placeholder="存在异常时必须填写备注"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item prop="fileList" label="附件">
              <file-upload v-model="formData.fileList"></file-upload>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item class="btn">
              <el-button @click="$router.back()">取消</el-button>
              <el-button type="primary" @click="submit">提交</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </custom-actions>
  </div>
</template>

<script>
export default {
  name: 'productionProcessAdd',
  data() {
    return {
      formData: {
        productionDate: '',
        inspectionType: '',
        specId: '',
        shelfLifeMonth: null,
        shelfLifeEndDate: '',
        productionLine: '',
        labelCorrect: '',
        sprayCodeCorrect: '',
        capIntact: '',
        bottleImpurity: '',
        bottleWallIntact: '',
        remark: '',
        fileList: [],
        reviewStatus: '1'
      },
      rules: {
        productionDate: [{ required: true, message: '请选择生产日期', trigger: 'change' }],
        inspectionType: [{ required: true, message: '请选择检验类型', trigger: 'change' }],
        specId: [{ required: true, message: '请选择产品规格', trigger: 'change' }],
        shelfLifeMonth: [{ required: true, message: '请填写保质期月份', trigger: 'change', type: 'number' }],
        shelfLifeEndDate: [{ required: true, message: '保质期至自动生成', trigger: 'change' }],
        productionLine: [{ required: true, message: '请输入生产线', trigger: 'blur' }],
        labelCorrect: [{ required: true, message: '请选择标签检查结果', trigger: 'change' }],
        sprayCodeCorrect: [{ required: true, message: '请选择喷码检查结果', trigger: 'change' }],
        capIntact: [{ required: true, message: '请选择压盖检查结果', trigger: 'change' }],
        bottleImpurity: [{ required: true, message: '请选择瓶内杂质检查结果', trigger: 'change' }],
        bottleWallIntact: [{ required: true, message: '请选择瓶外壁检查结果', trigger: 'change' }],
        remark: [
          {
            required: false,
            validator: (rule, value, callback) => {
              const arr = [
                this.formData.labelCorrect,
                this.formData.sprayCodeCorrect,
                this.formData.capIntact,
                this.formData.bottleImpurity,
                this.formData.bottleWallIntact
              ]
              if (arr.includes('2')) {
                if (!value) {
                  callback(new Error('存在异常项，请填写备注'))
                }
              }
              callback()
            },
            trigger: ['blur', 'change']
          }
        ]
      },
      loading: false,
      inspectionTypeArr: [
        { label: '生产过程首件检验', value: '1' },
        { label: '生产过程关键控制点', value: '2' }
      ],
      specList: []
    }
  },
  created() {
    this.loadSpec()
    if (this.checkId) {
      this.loadData()
    }
  },
  computed: {
    checkId() {
      return this.$route.query.checkId
    },
    hasErr() {
      const arr = [
        this.formData.labelCorrect,
        this.formData.sprayCodeCorrect,
        this.formData.capIntact,
        this.formData.bottleImpurity,
        this.formData.bottleWallIntact
      ]
      return arr.includes('2')
    }
  },
  methods: {
    // 根据生产日期 + 保质期月份 自动计算到期日
    calcExpireDate() {
      const { productionDate, shelfLifeMonth } = this.formData
      if (!productionDate || !shelfLifeMonth) {
        this.formData.shelfLifeEndDate = ''
        return
      }
      this.formData.shelfLifeEndDate = this.$dayjs(productionDate).add(shelfLifeMonth, 'month').subtract(1, 'day').format('YYYY‑MM‑DD')
    },
    loadSpec() {
      this.$axios
        .get(this.$apis.grainSpecifications.selectYxOilSpecByList)
        .then(res => {
          this.specList = res.list || []
        })
    },
    loadData() {
      this.loading = true
      this.$axios
        .get(this.$apis.productionProcess.selectPaProductionInspectionByCheckId, {
          params: { checkId: this.checkId }
        })
        .then(res => {
          res.fileList = res.fileList || []
          this.formData = res
        })
        .finally(() => {
          this.loading = false
        })
    },
    submit() {
      this.$refs.form.validate().then(() => {
        this.loading = true
        let url = this.$apis.productionProcess.insertPaProductionInspection
        if (this.checkId) {
          url = this.$apis.productionProcess.updatePaProductionInspection
        }
        this.$axios.post(url, { ...this.formData }).then(() => {
          this.$router.back()
        }).finally(() => {
          this.loading = false
        })
      })
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .el-form {
  .el-input-number,
  .el-select,
  .el-input,
  .el-date-editor {
    width: 100%;
    max-width: 400px;
  }
}
::v-deep .btn {
  .el-form-item__content {
    display: flex;
    gap:12px;
    justify-content: center;
  }
}
</style>
